import React from 'react'
import '../css/Navbar.css';
const Marquee = () => {
  return (
    <div className="alert-text marquee-container">

        <marquee style={{ color: "white" }} scrollamount="7">
          Travel Immigration - Your trusted partner for seamless visa processing and global mobility solutions; Google updates show increased demand for skilled immigration services worldwide; New visa policies announced for Canada, Australia, and Germany in 2024; Expert guidance for study visas, work permits, and permanent residency applications; Trusted by thousands of travelers for successful immigration journeys.

        </marquee>

    </div>
  )
}

export default Marquee
